/**
 * Jemné naskakování obsahu při scrollování.
 *
 * Prvky, které jsou při načtení pod ohybem stránky, dostanou třídu `.reveal`
 * (skryté, posunuté o kousek dolů) a jakmile se doscrolluje k nim, přidá se
 * `.is-visible` a plynule se objeví. Karty v mřížkách naskakují po sobě –
 * zpoždění řeší CSS přes :nth-child, protože hlavička CSP (style-src 'self')
 * nedovolí styl v atributu.
 *
 * Zásady:
 *   – bez JS nebo bez IntersectionObserver zůstane všechno normálně vidět
 *     (třída se nikdy nepřidá, obsah není závislý na skriptu)
 *   – co je vidět hned po načtení, se neanimuje – žádné bliknutí a
 *     nezdržuje se tím vykreslení hlavního obsahu (LCP)
 *   – při „omezit pohyb" v systému (prefers-reduced-motion) se nic neanimuje
 *     (WCAG 2.3.3)
 */

// Co se animuje jako celek
const BLOKY = [
    '.page-head',
    '.detail-feature',
    '.prose',
    '.block-image',
    '.contact-map',
    '.inquiry-form',
    '.inquiry-title',
    '.services-list-title, .why-us-title, .blog-title, .references-title, .reference-list-title',
    '.services-list-eyebrow, .why-us-eyebrow, .blog-eyebrow, .references-eyebrow, .reference-list-eyebrow',
    '.pagination',
];

// Mřížky, jejichž děti naskakují postupně
const MRIZKY = [
    '.services-grid',
    '.why-us-list',
    '.reference-grid',
    '.references-list',
    '.blog-list',
    '.gallery-grid',
    '.block-files',
    '.reference-filter',
];

function initReveal() {
    if (!('IntersectionObserver' in window)) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    // Délka animace (0,7 s) + zpoždění poslední karty v mřížce (11 × 70 ms)
    // – po téhle době třídy sundáme, ať prvek nezůstane „zamrzlý" v koncovém
    // snímku animace a fungovaly na něm vlastní efekty při najetí myší.
    const UKLID = 700 + 11 * 70 + 150;

    const observer = new IntersectionObserver((zaznamy, obs) => {
        zaznamy.forEach((z) => {
            if (!z.isIntersecting) return;
            const el = z.target;
            el.classList.add('is-visible');
            obs.unobserve(el);   // animujeme jednou, ne při každém projetí
            setTimeout(() => {
                el.classList.remove('reveal', 'reveal-stagger', 'is-visible');
            }, UKLID);
        });
    }, {
        // spustí se kousek předtím, než prvek doopravdy vyjede na obrazovku
        rootMargin: '0px 0px -8% 0px',
        threshold: 0.08,
    });

    // Práh, pod kterým má smysl animovat. Co začíná v horních ~70 % obrazovky,
    // je po načtení pořádně vidět a necháváme to být – jinak by úvod stránky
    // po otevření problikl.
    const ohyb = window.innerHeight * 0.7;

    const pripoj = (el, trida) => {
        if (el.dataset.revealInit) return;
        if (el.getBoundingClientRect().top < ohyb) return;   // je vidět rovnou
        // Uvnitř karuselu ne: snímky mimo obrazovku by se nikdy „nepotkaly"
        // s viewportem a zůstaly by neviditelné.
        if (el.closest('.swiper')) return;
        el.dataset.revealInit = '1';
        el.classList.add(trida);
        observer.observe(el);
    };

    document.querySelectorAll(BLOKY.join(',')).forEach((el) => pripoj(el, 'reveal'));
    document.querySelectorAll(MRIZKY.join(',')).forEach((el) => pripoj(el, 'reveal-stagger'));
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initReveal);
} else {
    initReveal();
}
